import { create } from "zustand";
import { Center } from "../types/center.types";

interface CentersStoreState {
	center: Center | null;
	centers: Center[] | null;
	setCurrentCenter: (center: Center | null) => void;
	setCenters: (centers: Center[] | null) => void;
}

export const useCentersStore = create<CentersStoreState>()((set) => ({
	center: null,
	centers: null,
	setCurrentCenter: (center: Center | null) => set(() => ({ center })),
	setCenters: (centers: Center[] | null) => set(() => ({ centers })),
}));
